import React from "react";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import Typography from "@material-ui/core/Typography";
import {Checkbox} from "primereact/checkbox";
import ContextMenu from "../../../components/contextMenu";
import {Calendar} from "primereact/calendar";
import {CALENDAR_ES, DATE_FORMAT_CALENDAR} from "../../../utils/constants/Constants";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";

const HistoricalReportView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <HeaderScreenPresval headerTitle="Reportes \ Préstamos Históricos"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.getDataReport}
                                             buttonName={"Parámetros"}
                                             disabledSearchButton = {props.disabledSearchButton}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Fecha Inicial" isBold={true}/>
                                    <Calendar name="startDate"
                                              locale={CALENDAR_ES}
                                              dateFormat={DATE_FORMAT_CALENDAR}
                                              disabledDays={[0, 6]}
                                              readOnlyInput={true}
                                              value={props.filters.startDate}
                                              onChange={props.onChangeFilters}
                                              maxDate={props.filters.today}
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange={CALENDAR_ES['yearRange']}
                                              showButtonBar={true}
                                    />
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Fecha Final" isBold={true}/>
                                    <Calendar name="finalDate"
                                              locale={CALENDAR_ES}
                                              dateFormat={DATE_FORMAT_CALENDAR}
                                              disabledDays={[0, 6]}
                                              readOnlyInput={true}
                                              value={props.filters.finalDate}
                                              onChange={props.onChangeFilters}
                                              minDate={props.filters.startDate}
                                              maxDate={props.filters.today}
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange={CALENDAR_ES['yearRange']}
                                              showButtonBar={true}
                                    />
                                </div>
                                <div className="p-col-12 p-md-6 p-col-6"/>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Mostrar sección" isBold={true}/>
                                    <Typography variant="subtitle2" gutterBottom
                                                style={{fontWeight: "bolder"}} className={"secondary-text"}>
                                        <Checkbox
                                            name="guaranteeCheck"
                                            checked={props.filters.guaranteeCheck}
                                            onChange={props.onChangeFilters}/>
                                        &nbsp;
                                        Garantías
                                    </Typography>
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Mostrar columna" isBold={true}/>
                                    <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder"}}
                                                className={"secondary-text"}>
                                        <Checkbox name="accountColumn"
                                                  checked={props.filters.accountColumn}
                                                  onChange={props.onChangeFilters}/>
                                        &nbsp; Cuenta
                                    </Typography>
                                </div>
                                <div className="p-col-12 p-md-6 p-col-6">
                                    <Button label="Limpiar"
                                            style={{'float': 'right'}}
                                            onClick={props.clearFilters}
                                            className="p-button-secondary"/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>

                    <Grid item xs={12} style={{textAlign: 'right'}}>
                        <ContextMenu menuOptions={props.exportOptions}
                                     isButton={true}
                                     label="Exportar"/>
                    </Grid>

                    <Grid item xs={12}>
                        <DataTable
                            className={"dataTable-vScroll"}
                            value={props.dataReport}
                            scrollable={true}
                            expandedRows={props.expandedRows}
                            selectionMode="single"
                            selection={props.selectedRow}
                            onSelectionChange={props.onSelectionChange}
                            rowExpansionTemplate={props.rowExpansionTemplate}
                            style={{width: '100%'}}
                            resizableColumns={true}
                            columnResizeMode={"fit"}
                            rows={props.rows}

                            totalRecords={props.totalRecords}
                            lazy={true}
                            first={props.first}
                            loading={props.loadingPage}
                            scrollHeight="600px"
                            virtualScroll={true}
                            virtualRowHeight={30}
                            onVirtualScroll={props.onVirtualScroll}>
                            {props.columns}
                        </DataTable>
                    </Grid>
                    {props.confMsg}
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default HistoricalReportView;